module.exports = __webpack_public_path__ + "static/adele_gold-3dddef3727643cc061e8379ad2a75263.svg";